export class VuexPersistHelper {
  static getRecipientIdFromUrl(url: string): string {
    const regex = /(?:v3|v|dsr)\/([^/]*?)\/([^/]*?)\/a\/([^/]*?)(?:\/|$)/;
    const match: boolean = regex.test(url);
    if (match) {
      const [, , recipientId]: RegExpMatchArray = url.match(regex);
      return recipientId;
    }
    return '';
  }

  static getSessionKey(url: string): string {
    const recipientId = this.getRecipientIdFromUrl(url);
    if (recipientId) {
      return `GA_SIGNING_PAGE_${recipientId}`;
    }
    return '';
  }

  static getPreviewKey(url: string): string {
    const regex = /(?:v3|v)\/(?:preview\/)(.*?)(?:\/|$|\?)/;
    const match: boolean = regex.test(url);
    let key = '';
    if (match) {
      const [, documentId]: RegExpMatchArray = url.match(regex);
      key = `GA_PREVIEW_${documentId}`;
    }
    return key;
  }
}
